import { actions as itemActions, reducers as itemReducers } from './Items.redux';

import React, { lazy } from 'react';

import { faCubesStacked } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { registerNavigation } from '@/core/navigation';
import { registerReduxStore } from '@/core/store';
import { registerRoutes } from '@/core/routes';

const ItemReservation = lazy(() =>
        import ('./ItemReservation/ItemReservation'));



registerReduxStore('items', itemReducers, itemActions);


registerRoutes([
    {
        path: '/item-reservation/view-all',
        exact: true,
        render: < ItemReservation />,
        title: 'Item Reservation',
        private: true,
        permissions: ['item_reservation'],
    },
]);

registerNavigation({
    title: 'Items',
    permissions: ['item_reservation_nav'],
    single: false,
    top: true,
    home: true,
    icon: < FontAwesomeIcon icon = { faCubesStacked }
    />,
    children: [{
        title: 'Item Reservation',
        url: '/item-reservation/view-all',
        permissions: ['item_reservation'],
    },
    ],
});




console.log('Registered Item Reservation Plugin');
